<template>
  <table class="dash-summary">
    <thead>
      <th style="width: 250px;">
        {{ title }}
      </th>
      <th colspan="3">Currently Active: {{ summary[0]['active'] }}</th>
    </thead>
    <tbody>
      <tr class="head">
        <td></td>
        <td class="text-right">Starts</td>
        <td class="text-right">Stops</td>
        <td class="text-right">Active</td>
      </tr>
      <tr v-for="(row, idx) in summary.slice(1)" :key="idx" class="body">
        <td>{{ rowLabels[idx] }}</td>
        <td class="text-right">{{ row['starts'] }}</td>
        <td class="text-right">{{ row['stops'] }}</td>
        <td class="text-right">{{ row['active'] }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    summary: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      rowLabels: ['This Week', 'Last Week', 'This Month', 'Last Month', 'This Year', 'Last Year']
    };
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';

.dash-summary {
  border: 1px solid $row-border;
  border-collapse: collapse;
  border-radius: 8px;
  padding: 8px;
  width: auto;
  font-size: 0.8rem;
  thead th {
    padding: 8px;
    border-bottom: 1px solid $row-border;
  }
  tbody tr.body {
    padding: auto;
    &:not(:last-of-type) {
      border-top: 1px solid $row-border;
    }

    &:nth-of-type(odd) {
      background-color: $light-grey-2;
    }
  }
  tbody tr td {
    padding: 8px;
  }

  .text-right {
    text-align: right;
  }
}
</style>
